import { Permission } from './permission.model';

export interface User {
  id: number;
  username: string;
  email: string;
  firstName: string;
  firstNameKey?: string;
  lastName: string;
  lastNameKey?: string;
  phone?: string;
  avatar?: string;
  isActive: boolean;
  isEmailVerified: boolean;
  lastLoginDate?: Date;
  createdDate: Date;
  updatedDate: Date;
  roleId: number;
  residentId?: number;
  vendorId?: number;
  preferences?: UserPreferences;
  permissions?: Permission[];
  twoFactorEnabled: boolean;
  passwordResetToken?: string;
  passwordResetExpires?: Date;
  emailVerificationToken?: string;
  emailVerificationExpires?: Date;
}

export interface UserPreferences {
  id: number;
  userId: number;
  language: string;
  timezone: string;
  theme: UserTheme;
  emailNotifications: boolean;
  smsNotifications: boolean;
  pushNotifications: boolean;
  dashboardLayout: DashboardLayout;
  dateFormat: string;
  timeFormat: '12h' | '24h';
  currency: string;
}

export enum UserTheme {
  LIGHT = 'light',
  DARK = 'dark',
  AUTO = 'auto',
}

export enum DashboardLayout {
  GRID = 'grid',
  LIST = 'list',
  COMPACT = 'compact',
}

export interface UserSession {
  id: number;
  userId: number;
  sessionToken: string;
  deviceInfo?: string;
  ipAddress?: string;
  userAgent?: string;
  isActive: boolean;
  createdDate: Date;
  lastActivityDate: Date;
  expiresDate: Date;
}

export interface UserActivity {
  id: number;
  userId: number;
  activityType: UserActivityType;
  description: string;
  metadata?: Record<string, any>;
  ipAddress?: string;
  userAgent?: string;
  timestamp: Date;
}

export enum UserActivityType {
  LOGIN = 'login',
  LOGOUT = 'logout',
  PASSWORD_CHANGE = 'password_change',
  PROFILE_UPDATE = 'profile_update',
  EMAIL_VERIFICATION = 'email_verification',
  TWO_FACTOR_ENABLED = 'two_factor_enabled',
  TWO_FACTOR_DISABLED = 'two_factor_disabled',
  PERMISSION_GRANTED = 'permission_granted',
  PERMISSION_REVOKED = 'permission_revoked',
  ROLE_CHANGED = 'role_changed',
  ACCOUNT_LOCKED = 'account_locked',
  ACCOUNT_UNLOCKED = 'account_unlocked',
  OTHER = 'other',
}
